import React from 'react';
import { useFormContext } from 'react-hook-form';
import { HelperText } from 'react-native-paper';
import { t } from '@lingui/macro';

import { Gender } from '@src/enums';
import { i18n } from '@src/i18n';

import { GenderPicker } from './styled';
import { EditProfileFormData } from './types';

type Props = {
  name: 'gender';
  label?: string;
  selectedGender?: Gender;
  disabled?: boolean;
};

const Component: React.FC<Props> = (props) => {
  const { name, label, selectedGender } = props;
  const { register, unregister, errors, setValue, watch } = useFormContext<
    EditProfileFormData
  >();
  const [show, setShow] = React.useState(false);
  const value = watch(name, selectedGender);
  const error = errors?.[name];

  const genderList = React.useMemo(
    () => [
      {
        label: i18n._(t`Male`),
        value: Gender.Male,
      },
      {
        label: i18n._(t`Female`),
        value: Gender.Female,
      },
      {
        label: i18n._(t`Rather Not Say`),
        value: Gender.RatherNotSay,
      },
    ],
    []
  );

  const handleChangeGender = React.useCallback(
    (input: Gender) => {
      setValue(name, input);
    },
    [name, setValue]
  );

  React.useEffect(() => {
    register(name);
    return () => unregister(name);
  }, [name, register, unregister]);

  React.useEffect(() => {
    if (selectedGender) {
      setValue(name, selectedGender);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGender]);

  return (
    <>
      <GenderPicker
        label={label}
        value={value}
        setValue={handleChangeGender}
        list={genderList}
        visible={show}
        placeholder={i18n._(t`Select Gender`)}
        onShow={() => setShow(true)}
        onDismiss={() => setShow(false)}
      />
      <HelperText type="error" visible={!!error}>
        {error?.message}
      </HelperText>
    </>
  );
};

export default React.memo(Component);
